import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ROLE_FALLBACK = {
  ADMIN: '/admin/monitor/system',
};

export function ProtectedRoute({ children, deniedRoles, allowedRoles }) {
  const { token, user } = useAuth();
  if (!token) return <Navigate to="/admin/login" replace />;
  if (deniedRoles && user?.role && deniedRoles.includes(user.role)) {
    return <Navigate to={ROLE_FALLBACK[user.role] || '/admin/login'} replace />;
  }
  if (allowedRoles && user?.role && !allowedRoles.includes(user.role)) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return children;
}
